import classNames from 'classnames';

interface IndicatorProps {
  variant: string;
}

const Indicator = ({ variant }: IndicatorProps) => {
  return (
    <div className="color-section mb-1">
      <div className={classNames('indicator', variant, 'mr-2')} />
      <div className="text">{`$${variant}`}</div>
    </div>
  );
};

export const Colors = () => {
  return (
    <div className="colors-test px-1 pt-1">
      <div className="d-flex">
        <div className="section">
          <div className="title mb-2">Background color</div>
          <div>
            <Indicator variant="ui-background-01" />
            <Indicator variant="ui-background-02" />
            <Indicator variant="ui-background-03" />
            <Indicator variant="ui-background-04" />
            <Indicator variant="ui-background-05" />
            <Indicator variant="ui-background-06" />
            <Indicator variant="ui-background-07" />
            <Indicator variant="ui-background-08" />
            <Indicator variant="ui-background-09" />
            <Indicator variant="ui-background-10" />
          </div>
          <div className="title mb-2 mt-2">Text color</div>
          <div>
            <Indicator variant="text-01" />
            <Indicator variant="text-02" />
            <Indicator variant="text-03" />
            <Indicator variant="text-04" />
            <Indicator variant="text-05" />
            <Indicator variant="text-06" />
            <Indicator variant="text-07" />
            <Indicator variant="text-08" />
            <Indicator variant="text-09" />
            <Indicator variant="text-10" />
          </div>
        </div>
        <div className="section">
          <div className="title mb-2">UI color</div>
          <div>
            <Indicator variant="ui-01" />
            <Indicator variant="ui-02" />
            <Indicator variant="ui-03" />
            <Indicator variant="ui-04" />
            <Indicator variant="divider-01" />
            <Indicator variant="ui-05" />
            <Indicator variant="ui-06" />
            <Indicator variant="ui-07" />
            <Indicator variant="ui-08" />
            <Indicator variant="ui-09" />
            <Indicator variant="ui-10" />
            <Indicator variant="ui-11" />
            <Indicator variant="ui-12" />
            <Indicator variant="ui-13" />
          </div>
        </div>
      </div>
    </div>
  );
};
